export const INSURANCE = Object.freeze({
    REGISTRATION_CANCELLATION_INSURANCE:"registration-cancellation",
    GAP_MEDICAL_INSURANCE:"gap-medical"

})

export const CONFIRMATION_MESSAGES= Object.freeze({
    STORE_CATERGORY_DELETE: "Data can't be recoverd after this action. Are you sure you want to delete this category ?"
})